import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-109ec028"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "coockie-bar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("На этом сайте мы используем cookies, чтобы всё работало как надо, а аналитика сайта соответствовала "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://samokat.ru/privacy",
    target: "_blank"
  }, "Политике конфиденциальности")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LetoButton = _resolveComponent("LetoButton")!

  return (_ctx.hideBar)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_LetoButton, {
          class: "btn-small",
          onClick: _ctx.accept,
          text: "OK"
        }, null, 8, ["onClick"])
      ]))
    : _createCommentVNode("", true)
}